<template>
  <span v-if="$store.state.address.google">
    <template v-if="loaded">
      <div>
        <span>
          {{ distance }},
          {{ duration }}
        </span>
      </div>
    </template>
    <template v-else>
      <font-awesome-icon :icon="['fal', 'spinner']" spin />
    </template>
  </span>
</template>

<script type="text/babel">
/* eslint-disable no-undef */
export default {
  props: {
    address1: {
      type: [String, Number, Object],
      required: true,
    },
    address2: {
      type: [String, Number, Object],
      required: true,
    },
  },

  data() {
    return {
      loaded: false,
      googleData: null,

      distance: null,
      duration: null,
    };
  },

  mounted() {
    this.distance = null;
    this.duration = null;

    // noinspection JSUnresolvedFunction
    const service = new google.maps.DistanceMatrixService();

    // noinspection JSUnresolvedFunction
    return service.getDistanceMatrix(
      {
        origins: [this.getAddressString(this.address1)],
        destinations: [this.getAddressString(this.address2)],
        travelMode: "DRIVING",
      },
      (response) => {
        this.distance = this.$lodash.get(response, "rows[0].elements[0].distance.text");
        this.duration = this.$lodash.get(response, "rows[0].elements[0].duration.text");

        this.googleData = JSON.stringify(response, null, 2);
        this.loaded = true;
      }
    );
  },

  methods: {
    getAddressString(address) {
      let result = "";

      if (address === Object(address)) {
        result = this.$lodash.get(address, "formatted", this.$lodash.get(address, "postcode"));
      } else {
        result = address.trim();
      }

      return `${result.trim()}, Australia`;
    },
  },
};
</script>
